import { memo } from 'react'
import { Button as MuiButton, SxProps, ButtonProps as MuiButtonProps } from '@mui/material'
import { Text } from '@/components/Data'
import { Spinner } from '@/components/Feedback'
import { ButtonProps } from './Button.types'
import { buttonStyles as styles } from './Button.style'

function Button({
  children,
  color = 'primary',
  noBorder = false,
  sx,
  textProps = {},
  ...rest
}: ButtonProps) {
  const { sx: textSx, ...otherTextProps } = textProps
  return (
    <MuiButton
      sx={
        [
          styles.button,
          rest.size === 'small' && styles.small,
          rest.size === 'large' && styles.large,
          noBorder && styles.noBorders,
          // Spread, never nested: MUI walks an `sx` array one level only, so an
          // array passed in would be read as style keys "0", "1" and dropped.
          ...(Array.isArray(sx) ? sx : [sx]),
        ] as SxProps
      }
      variant="contained"
      loadingIndicator={<Spinner />}
      color={color as MuiButtonProps['color']}
      {...rest}>
      <Text
        sx={[styles.text, ...(Array.isArray(textSx) ? textSx : [textSx])] as SxProps}
        component={'span'}
        {...otherTextProps}>
        {children}
      </Text>
    </MuiButton>
  )
}

export default memo(Button)
